import _regenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/fafee/Work/Loginet/InternalPortal/internal-portal/portal-client/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.flat-map.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "flex flex-col !border-surface-100 pb-3.5 px-3.5 gap-2"
};
var _hoisted_2 = {
  key: 0,
  class: "pt-3.5"
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = {
  class: "text-center text-sm text-surface-300 dark:text-surface-950 my-10"
};
var _hoisted_5 = {
  key: 2
};
var _hoisted_6 = {
  class: "flex flex-row gap-2 pt-3.5 pl-2"
};
var _hoisted_7 = {
  class: "font-medium uppercase text-surface-400 text-sm"
};
var _hoisted_8 = ["onClick"];
var _hoisted_9 = {
  class: "flex flex-col gap-1"
};
var _hoisted_10 = {
  class: "text-sm font-semibold text-surface-900"
};
var _hoisted_11 = {
  class: "text-sm"
};
var _hoisted_12 = {
  class: "flex flex-col justify-center align-middle content-center ml-auto min-w-8"
};
var _hoisted_13 = {
  key: 0,
  class: "text-xxl fa-regular fa-arrow-turn-down-left text-primary-500"
};
var _hoisted_14 = {
  key: 1,
  class: "flex flex-col !border-surface-100 pb-3.5 px-3.5 gap-2"
};
var _hoisted_15 = {
  class: "flex flex-col gap-2"
};
var _hoisted_16 = {
  class: "flex flex-row gap-2"
};
var _hoisted_17 = {
  class: "font-medium uppercase text-surface-400 dark:text-surface-950 pl-2 text-sm"
};
var _hoisted_18 = {
  key: 0,
  class: "flex flex-col"
};
var _hoisted_19 = ["onClick"];
var _hoisted_20 = {
  class: "flex flex-col justify-center items-end w-[10%]"
};
var _hoisted_21 = ["onClick"];
var _hoisted_22 = {
  key: 1
};
var _hoisted_23 = {
  class: "text-center text-sm text-surface-300 dark:text-surface-950"
};
var _hoisted_24 = {
  key: 0,
  class: "flex flex-row gap-5 p-3.5 !text-surface-600 justify-end"
};
var _hoisted_25 = {
  class: "flex flex-row gap-2 items-center"
};
var _hoisted_26 = {
  class: "text-color dark:text-surface-950 text-sm"
};
var _hoisted_27 = {
  class: "flex flex-row gap-2 items-center"
};
var _hoisted_28 = {
  class: "text-color dark:text-surface-950 text-sm"
};
var _hoisted_29 = {
  class: "flex flex-row gap-2 items-center"
};
var _hoisted_30 = {
  class: "flex flex-col gap-1 justify-center align-middle content-center"
};
var _hoisted_31 = {
  class: "p-1.5 bg-surface-100 text-surface-500 rounded text-sm"
};
var _hoisted_32 = {
  class: "text-color dark:text-surface-950 text-sm"
};
import { useStore } from "vuex";
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useDebounceFn } from "@vueuse/core";
import network from "@/utils/network";
import { localFetch, tenantIdFromPath } from "@/utils/util";
import { PRIVILEGES } from "@/utils/const";
var regularSearchPrivileges = "meili.search.profile,meili.search.time_off,meili.search.sitemap";
var elevatedSearchPrivileges = "meili.search.profile,meili.search.time_off,meili.search.resource,meili.search.competency,meili.search.logged_time,meili.search.sitemap,meili.search.project";
export default {
  __name: 'CommandKSearch',
  setup: function setup(__props) {
    var store = useStore();
    var userId = computed(function () {
      return store.getters["session/userId"];
    });
    var router = useRouter();
    var axios = network.createAxiosInstance();
    var query = ref("");
    var querying = ref(false);
    var searchVisible = ref(false);
    var searchResults = ref([]);
    var recents = ref([]);
    var selectedIndex = ref(-1);
    var navigateTo = function navigateTo(url) {
      if (url) {
        router.push(url);
        searchVisible.value = false;
        query.value = "";
        selectedIndex.value = -1;
      }
    };
    var isSelected = function isSelected(result) {
      var flatResults = searchResults.value.flatMap(function (c) {
        return c.results;
      });
      return flatResults.indexOf(result) === selectedIndex.value;
    };
    var fetchRecents = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var recentCall;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return axios.get("/meili/recent", {
                headers: {
                  "X-Tenant-Key": tenantIdFromPath(),
                  "X-User-Id": userId.value
                }
              });
            case 1:
              recentCall = _context.v;
              recents.value = recentCall.data;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function fetchRecents() {
        return _ref.apply(this, arguments);
      };
    }();
    var deleteRecent = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(recentId) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return axios.delete("/meili/recent?recent_id=".concat(recentId), {
                headers: {
                  "X-Tenant-Key": tenantIdFromPath()
                }
              });
            case 1:
              recents.value = recents.value.filter(function (recent) {
                return recent.id !== recentId;
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function deleteRecent(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    var selectRecentQuery = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(recentId) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              query.value = recents.value.find(function (recent) {
                return recent.id === recentId;
              }).query;
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      return function selectRecentQuery(_x2) {
        return _ref3.apply(this, arguments);
      };
    }();
    var activateSearch = function activateSearch() {
      query.value = "";
      searchVisible.value = !searchVisible.value;
    };
    var toggleSearch = function toggleSearch(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        activateSearch();
      } else if (event.key === "Escape" && searchVisible.value) {
        searchVisible.value = false;
        query.value = "";
        selectedIndex.value = -1;
        searchResults.value = [];
        recents.value = [];
        querying.value = false;
      }
    };
    var handleResults = function handleResults(hits) {
      var categories = [];
      hits.sort(function (a, b) {
        return b._federation.weightedRankingScore - a._federation.weightedRankingScore;
      });
      categories.push({
        top: true,
        label: "meili.category.top",
        results: hits.slice(0, 5)
      });
      hits.slice(5).forEach(function (hit) {
        var category = categories.find(function (c) {
          return c.label === hit.category;
        });
        if (!category) {
          categories.push({
            label: hit.category,
            results: [hit]
          });
        } else {
          category.results.push(hit);
        }
      });
      return categories;
    };
    var performSearch = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var response, _t;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!(query.value.trim().length >= 3)) {
                _context4.n = 6;
                break;
              }
              _context4.p = 1;
              querying.value = true;
              searchResults.value = [];
              _context4.n = 2;
              return queryMeiliSearch();
            case 2:
              response = _context4.v;
              _context4.n = 3;
              return fetchRecents();
            case 3:
              searchResults.value = handleResults(response.data.hits);
              querying.value = false;
              _context4.n = 5;
              break;
            case 4:
              _context4.p = 4;
              _t = _context4.v;
              console.error("Search failed:", _t);
              querying.value = false;
            case 5:
              _context4.n = 7;
              break;
            case 6:
              searchResults.value = [];
              querying.value = false;
            case 7:
              return _context4.a(2);
          }
        }, _callee4, null, [[1, 4]]);
      }));
      return function performSearch() {
        return _ref4.apply(this, arguments);
      };
    }();
    var debouncedSearch = useDebounceFn(performSearch, 300);
    var userPrivileges = computed(function () {
      return store.getters["session/hasAnyAuthority"](PRIVILEGES.ENTERPRISE.PROJECT.CREATE, PRIVILEGES.ENTERPRISE.PROJECT.ADMIN) ? elevatedSearchPrivileges : regularSearchPrivileges;
    });
    var queryMeiliSearch = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _localFetch;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return axios.get("/meili/search/".concat(query.value.trim()), {
                headers: {
                  "X-Tenant-Key": tenantIdFromPath(),
                  "X-User-Id": userId.value,
                  "X-User-Privileges": userPrivileges.value,
                  //TODO: TEMPORARY, super-unsafe
                  "X-Language-Code": (_localFetch = localFetch("stored_locale")) !== null && _localFetch !== void 0 ? _localFetch : "hu"
                }
              });
            case 1:
              return _context5.a(2, _context5.v);
          }
        }, _callee5);
      }));
      return function queryMeiliSearch() {
        return _ref5.apply(this, arguments);
      };
    }();
    var searchNavigationHandler = function searchNavigationHandler(event) {
      if (!searchVisible.value) return;
      var flatResults = searchResults.value.flatMap(function (c) {
        return c.results;
      });
      var maxIndex = flatResults.length - 1;
      switch (event.key) {
        case "ArrowDown":
          event.preventDefault();
          selectedIndex.value = Math.min(selectedIndex.value + 1, maxIndex);
          break;
        case "ArrowUp":
          event.preventDefault();
          selectedIndex.value = Math.max(selectedIndex.value - 1, 0);
          break;
        case "Enter":
          event.preventDefault();
          if (selectedIndex.value >= 0 && selectedIndex.value <= maxIndex) {
            navigateTo(flatResults[selectedIndex.value].url);
          }
          break;
      }
    };
    var isDialogFooterVisible = computed(function () {
      return !querying.value && hasAnyResults.value;
    });
    var hasAnyResults = computed(function () {
      return searchResults.value.some(function (c) {
        return c.results.length > 0;
      });
    });
    var cleanSearch = function cleanSearch() {
      selectedIndex.value = -1;
      searchResults.value = [];
    };
    watch(query, /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(newValue) {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              if (newValue.trim().length >= 3) {
                cleanSearch();
                querying.value = true;
                debouncedSearch();
              } else {
                cleanSearch();
                searchResults.value = [];
              }
              if (!(newValue.trim().length === 0)) {
                _context6.n = 1;
                break;
              }
              _context6.n = 1;
              return fetchRecents();
            case 1:
              return _context6.a(2);
          }
        }, _callee6);
      }));
      return function (_x3) {
        return _ref6.apply(this, arguments);
      };
    }());
    watch([query, searchVisible], function () {
      selectedIndex.value = -1;
    });
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.n) {
          case 0:
            window.addEventListener("keydown", toggleSearch);
            window.addEventListener("keydown", searchNavigationHandler);
            _context7.n = 1;
            return fetchRecents();
          case 1:
            return _context7.a(2);
        }
      }, _callee7);
    })));
    onUnmounted(function () {
      window.removeEventListener("keydown", toggleSearch);
      window.removeEventListener("keydown", searchNavigationHandler);
    });
    return function (_ctx, _cache) {
      var _component_Button = _resolveComponent("Button");
      var _component_InputIcon = _resolveComponent("InputIcon");
      var _component_InputText = _resolveComponent("InputText");
      var _component_IconField = _resolveComponent("IconField");
      var _component_Skeleton = _resolveComponent("Skeleton");
      var _component_Dialog = _resolveComponent("Dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Button, {
        icon: "fa-regular fa-magnifying-glass",
        variant: "text",
        severity: "contrast",
        "aria-haspopup": "true",
        "aria-controls": "icon_menu",
        onClick: activateSearch,
        size: "small",
        pt: {
          root: {
            class: 'hover:!bg-surface-100'
          },
          icon: {
            class: '!text-surface-700'
          }
        }
      }), _createVNode(_component_Dialog, {
        visible: searchVisible.value,
        "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
          return searchVisible.value = $event;
        }),
        modal: "",
        header: "Search",
        class: "w-[90vw] md:w-[45vw]",
        closable: false,
        draggable: false,
        dismissableMask: "",
        pt: {
          root: {
            class: '!bg-surface-0 !border-0 dark:!border',
            style: {
              '--p-dialog-border-color': 'var(--p-surface-100)'
            }
          },
          mask: {
            class: 'dark:!bg-[#000000e6]'
          },
          content: {
            class: 'p-0'
          },
          footer: {
            class: ['p-0', {
              '!border-t dark:!border-t-surface-100': isDialogFooterVisible.value
            }]
          },
          header: {
            class: ['p-0', {
              '!border-b dark:!border-b-surface-100': querying.value || hasAnyResults.value || query.value.length >= 3
            }]
          }
        }
      }, {
        header: _withCtx(function () {
          return [_createVNode(_component_IconField, {
            class: "w-full p-3 relative"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_InputIcon, {
                class: "fa-regular fa-magnifying-glass pl-2.5 !text-surface-400"
              }), _createVNode(_component_InputText, {
                modelValue: query.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return query.value = $event;
                }),
                placeholder: _ctx.$tf('search.commandK.placeholder'),
                autofocus: "",
                class: "w-full",
                pt: {
                  root: {
                    class: '!border-0 !shadow-none !bg-surface-0 !border-surface-200 !text-surface-400 !shadow-none !text-[1.188rem] !pl-10',
                    style: {
                      '--p-inputtext-placeholder-color': 'var(--p-surface-400)'
                    }
                  }
                }
              }, null, 8, ["modelValue", "placeholder"]), _cache[2] || (_cache[2] = _createElementVNode("div", {
                class: "absolute right-5 top-[1.375rem] bottom-0 flex items-center justify-center gap-0.5 p-1 bg-surface-100 rounded border border-surface-200 h-6"
              }, [_createElementVNode("kbd", {
                class: "text-surface-600 text-xl"
              }, "⌘"), _createElementVNode("kbd", {
                class: "text-surface-600 text-sm"
              }, "K")], -1))];
            }),
            _: 1
          })];
        }),
        footer: _withCtx(function () {
          return [isDialogFooterVisible.value ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "flex flex-col gap-1 justify-center align-middle content-center"
          }, [_createElementVNode("i", {
            class: "fa-regular fa-arrow-turn-down-left px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
          })], -1)), _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$tf("search.commandK.toSelect")), 1)]), _createElementVNode("div", _hoisted_27, [_cache[5] || (_cache[5] = _createElementVNode("div", {
            class: "flex flex-col gap-1 justify-center align-middle content-center"
          }, [_createElementVNode("i", {
            class: "fa-regular fa-arrow-up px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
          })], -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "flex flex-col gap-1 justify-center align-middle content-center"
          }, [_createElementVNode("i", {
            class: "fa-regular fa-arrow-down px-1.5 py-1.5 bg-surface-100 text-surface-500 w-8 rounded text-sm"
          })], -1)), _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$tf("search.commandK.toNavigate")), 1)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$tf("search.commandK.toEscape")), 1)]), _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$tf("search.commandK.toClose")), 1)])])) : _createCommentVNode("", true)];
        }),
        default: _withCtx(function () {
          return [querying.value || hasAnyResults.value || query.value.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [querying.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Skeleton, {
            class: "my-2",
            width: "50%",
            height: "24px"
          }), _createVNode(_component_Skeleton, {
            class: "my-2",
            width: "100%",
            height: "12px"
          }), _createVNode(_component_Skeleton, {
            class: "my-2",
            width: "80%",
            height: "12px"
          })])) : _createCommentVNode("", true), !querying.value && !hasAnyResults.value && query.value.length >= 3 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tf("search.commandK.noResults")), 1)])) : _createCommentVNode("", true), hasAnyResults.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, function (category) {
            return _openBlock(), _createElementBlock("div", {
              class: "flex flex-col gap-2",
              key: category.label
            }, [_createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$tf(category.label)), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.results, function (result) {
              return _openBlock(), _createElementBlock("div", {
                class: "flex",
                key: result.id
              }, [_createElementVNode("div", {
                class: _normalizeClass(["w-full flex flex-row gap-5 px-[1.125rem] py-2.5 cursor-pointer bg-surface-50 hover:bg-surface-200 transition-colors duration-200 !text-surface-600 rounded-lg", {
                  'bg-surface-200': isSelected(result),
                  'bg-surface-100 hover:bg-surface-200': !isSelected(result)
                }]),
                onClick: function onClick($event) {
                  return navigateTo(result.url);
                }
              }, [_cache[3] || (_cache[3] = _createElementVNode("div", {
                class: "flex flex-col justify-center align-middle content-center"
              }, [_createElementVNode("i", {
                class: "fa-regular fa-hashtag text-surface-500 text-sm"
              })], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(result.title), 1), _createElementVNode("p", _hoisted_11, _toDisplayString(result.description), 1)]), _createElementVNode("div", _hoisted_12, [isSelected(result) ? (_openBlock(), _createElementBlock("i", _hoisted_13)) : _createCommentVNode("", true)])], 10, _hoisted_8)]);
            }), 128))]);
          }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), query.value.length === 0 && !querying.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$tf("search.commandK.recent")), 1)]), recents.value.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recents.value.slice(0, 10), function (recentResult) {
            return _openBlock(), _createElementBlock("div", {
              key: recentResult.id,
              class: "flex justify-between w-full text-sm hover:bg-surface-100 text-surface-900 hover:text-primary-400 p-2 rounded-md cursor-pointer"
            }, [_createElementVNode("p", {
              onClick: _withModifiers(function ($event) {
                return selectRecentQuery(recentResult.id);
              }, ["prevent"]),
              class: "w-[90%]"
            }, _toDisplayString(recentResult.query), 9, _hoisted_19), _createElementVNode("div", _hoisted_20, [_createElementVNode("i", {
              class: "fa-regular fa-xmark cursor-pointer",
              onClick: _withModifiers(function ($event) {
                return deleteRecent(recentResult.id);
              }, ["prevent"])
            }, null, 8, _hoisted_21)])]);
          }), 128))])) : recents.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$tf("search.commandK.noRecentSearches")), 1)])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["visible", "pt"])]);
    };
  }
};